
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from "next/dynamic";
import Head from "next/head";
// No SSR for TV display (uses WebSocket + browser APIs)
const TVDisplay = dynamic(() => import("../../modules/chessparty/TVDisplay"), { ssr: false });
export default function TVPage() {
    return (<>
      <Head>
        <title>Chess Hotel | Festival Live</title>
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
      </Head>
      <TVDisplay />
    </>);
}

    async function __Next_Translate__getStaticProps__1a0fc0d51e9__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/chessparty/tv',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0fc0d51e9__ as getStaticProps }
  